<template lang="pug">
  div
    Card.a8-page-description-card
        h2 {{$t('certsApply.pageTitleText')}}

        Tabs(v-model="currentTab" )
            template(v-for="(tab,index) in tabItems")
                TabPane(:label="$t(`certsApply.${tab.name}`)" :name="tab.name")
                    RcmTable(
                        :esIndex="tab.esIndex"
                        :esIndexFields="tab.esIndexFields"
                        :exportFields="tab.exportFields"
                        :sort="tab.sort"
                        :userCanCreate="tab.userCanCreate"
                        :userCanIndex="false"
                        :userCanEditFilters="false"
                        :userCanEditColumns="false"
                        :userCanExport="false"
                        ref="rcmTable"
                        v-bind:searchView="$options.name"
                        :primarySearchKey="tab.primarySearchKey"
                        :primarySearchKeyI18="tab.primarySearchKeyI18"
                        :userCanToggleFuzzySearch="tab.userCanToggleFuzzySearch"
                        :rowClassInfo="rowClassInfo")
</template>
<script>
import Vue from "vue";
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("TagList", TagList);

import RcmTable from "@/components/RcmTable_v2";
import JsonPoptip from "@/components/JsonPoptip";
import TagList from "@/components/TagList";
import { action, deleteAction } from "./fields.js";

export default {
    name: "CertsApply",
    components: { RcmTable, TagList, JsonPoptip },
    data() {
        return {
            currentTab: "queues",
            tabItems: [
                {
                    name: "queues",
                    esIndex: "rcm-acme-queues",
                    esIndexFields: {
                        action: deleteAction(this, 0),
                        fastEntry: "",
                        queueState: "",
                        groupName: "",
                        serverName: "",
                        sslProvider: "",
                        requestSSLOrderNumber: "",
                        requestSSLState: "",
                        collectSSLState: "",
                        requestAttemptCount: "",
                        collectAttemptCount: "",
                        requestSSLErrMsg: "",
                        collectSSLErrMsg: "",
                        // taskAction: "",
                        addToQueueDate: "",
                        requestSSLDate: "",
                        collectSSLDate: "",
                        requestSSLlValidateFileName: "",
                    },
                    exportFields: [
                        "queueState",
                        "groupName",
                        "serverName",
                        "sslProvider",
                        "requestSSLOrderNumber",
                        "requestSSLState",
                        "collectSSLState",
                        "requestAttemptCount",
                        "collectAttemptCount",
                        "requestSSLErrMsg",
                        "collectSSLErrMsg",
                        "taskAction",
                        "addToQueueDate",
                        "requestSSLDate",
                        "collectSSLDate",
                        "requestSSLlValidateFileName",
                    ],
                    userCanCreate: true,
                    primarySearchKey: "serverName",
                    primarySearchKeyI18: "域名名稱",
                    userCanToggleFuzzySearch: true,
                    // sort: [{ fastEntry: { order: "desc" } }, { addToQueueDate: { order: "desc" } }],
                    // sort: [{ addToQueueDate: { order: "asc" } }],
                },
                {
                    name: "fastEntry",
                    esIndex: "rcm-acme-domainlist",
                    esIndexFields: { action: action(this, 1), domains: {}, domainFilter: "fastentry" },
                    userCanCreate: false,
                    primarySearchKey: false,
                    primarySearchKeyI18: false,
                    userCanToggleFuzzySearch: false,
                },
                {
                    name: "cnameAllowList",
                    esIndex: "rcm-acme-domainlist",
                    esIndexFields: { action: action(this, 2), domains: {}, domainFilter: "whitelist" },
                    userCanCreate: false,
                    primarySearchKey: false,
                    primarySearchKeyI18: false,
                    userCanToggleFuzzySearch: false,
                },
                {
                    name: "black",
                    esIndex: "rcm-acme-domainlist",
                    esIndexFields: { action: action(this, 3), domains: {}, domainFilter: "blacklist" },
                    userCanCreate: false,
                    primarySearchKey: false,
                    primarySearchKeyI18: false,
                    userCanToggleFuzzySearch: false,
                },
            ],
            rowClassInfo: {
                key: "state",
                values: [],
                valuesNot: ["完成"],
                className: "table-disabled-row",
                defaultClassName: "",
            },
            generalFields: [],
        };
    },
    methods: {},
    computed: {},
};
</script>



// WEBPACK FOOTER //
// src/view/monitor/CertsApply.vue